import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ThemeService, AuthService } from '../../providers/index';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  public project: string; //TODO

  constructor(public navCtrl: NavController,
              private _theme: ThemeService, private _auth: AuthService) {
    this.project = this._theme.getSlogan();

  }

  login(userEmail,userPassword): void {
    console.log('authenticating with local credentials');
    this._auth.signInWithFirebaseCredentials(userEmail,userPassword)
      .then(() => this.onSignInSuccess());
  }

  private onSignInSuccess(): void {
    console.log("Display name ",this._auth.displayName());
    console.log("Display email ",this._auth.displayEmail());
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Authenticated so you cannot see this page: ');
      return false;
    } else {
      console.log('Authenticated so you can see this page: '); //TODO: Add reference to page
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts